import originalFields from 'components/forms/application_original/fields';

const fields = {
    endorsement_text: {
        ...originalFields.endorsement_text,
    },
};

export default fields;
